export const appTheme = {
    colors: {
        pageText: "#ffffff",
        accent: "#67e8f9",
        muted: "rgba(255,255,255,0.78)",
        mutedSoft: "rgba(255,255,255,0.72)",
        cardBg: "rgba(10,18,30,0.88)",
        cardBorder: "rgba(255,255,255,0.10)",
        shellBorder: "rgba(35, 211, 238, 0.28)",
        shellBg: "linear-gradient(180deg, rgba(8,16,28,0.94) 0%, rgba(4,9,18,0.97) 100%)",
        buttonBg: "rgba(255,255,255,0.04)",
        buttonBorder: "rgba(255,255,255,0.12)",
    },
    fonts: {
        body: 'Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    shadows: {
        shell: "0 0 0 1px rgba(255,255,255,0.03), 0 0 34px rgba(0,220,255,0.10), 0 22px 80px rgba(0,0,0,0.46)",
        card: "0 0 0 1px rgba(103,232,249,0.04) inset",
    },
};
export const pageStyles = {
    page: {
        minHeight: "100vh",
        background: "radial-gradient(circle at top center, rgba(0,220,255,0.08), transparent 24%), linear-gradient(180deg, #00050d 0%, #000814 45%, #00030a 100%)",
        color: appTheme.colors.pageText,
        padding: "28px 18px 40px",
        boxSizing: "border-box",
        fontFamily: appTheme.fonts.body,
    },
    shell: {
        maxWidth: "1180px",
        margin: "0 auto",
        borderRadius: "24px",
        border: `1px solid ${appTheme.colors.shellBorder}`,
        background: appTheme.colors.shellBg,
        boxShadow: appTheme.shadows.shell,
        padding: "28px 24px 22px",
        boxSizing: "border-box",
    },
    kicker: {
        color: appTheme.colors.accent,
        fontSize: "12px",
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        marginBottom: "8px",
    },
    title: {
        margin: 0,
        fontSize: "clamp(28px, 4vw, 46px)",
        lineHeight: 1.02,
        color: "#ffffff",
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        fontWeight: 800,
    },
    subtitle: {
        marginTop: "14px",
        marginBottom: 0,
        maxWidth: "860px",
        color: appTheme.colors.muted,
        lineHeight: 1.7,
        fontSize: "15px",
    },
    topRow: {
        marginBottom: "24px",
    },
    button: {
        padding: "12px 16px",
        borderRadius: "12px",
        border: `1px solid ${appTheme.colors.buttonBorder}`,
        background: appTheme.colors.buttonBg,
        color: "#fff",
        cursor: "pointer",
        fontWeight: 700,
    },
};
